import React from "react";

export const OrganizationsIcon = (props: React.SVGAttributes<SVGElement>) => {
  return (
    <svg
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_5969_10756)">
        <rect x="7" y="7" width="57" height="57" rx="28.5" fill="#F7F8FA" />
        <rect x="7.5" y="7.5" width="56" height="56" rx="28" stroke="#EBEDF2" />
      </g>
      <path
        d="M46.2409 27.8869C48.3865 25.7498 46.8479 21.9928 43.7864 22C40.725 21.9928 39.1864 25.7504 41.3321 27.8869C41.1665 27.9757 41.0062 28.073 40.8519 28.1785C37.4329 25.8067 32.5671 25.8068 29.1482 28.1785C28.9939 28.0731 28.8336 27.9757 28.668 27.8869C30.8135 25.7498 29.275 21.9928 26.2135 22C23.1521 21.9928 21.6134 25.7504 23.7592 27.8869C22.1185 28.7661 21 30.4975 21 32.4854V34.2427C21 34.6957 21.3673 35.063 21.8203 35.063H24.6718C23.8571 39.3847 26.0901 44.0133 29.9632 46.0756C29.8482 46.5054 29.7865 46.9568 29.7865 47.4224V49.1797C29.7865 49.6327 30.1538 50 30.6068 50H39.3933C39.8463 50 40.2136 49.6327 40.2136 49.1797V47.4224C40.2136 46.9569 40.1519 46.5055 40.0369 46.0757C43.9101 44.0132 46.1429 39.3848 45.3282 35.063H48.1797C48.6327 35.063 49 34.6958 49 34.2427V32.4855C49 30.4975 47.8815 28.7661 46.2409 27.8869ZM43.7865 23.6406C44.7876 23.6406 45.6021 24.4552 45.6021 25.4563C45.5024 27.8649 42.0702 27.8642 41.9709 25.4563C41.9709 24.4551 42.7853 23.6406 43.7865 23.6406ZM26.2135 23.6406C27.2146 23.6406 28.0291 24.4552 28.0291 25.4563C27.9294 27.8649 24.4973 27.8642 24.3979 25.4563C24.3979 24.4551 25.2124 23.6406 26.2135 23.6406ZM22.6406 33.4224V32.4855C22.8374 27.7443 29.5914 27.748 29.7865 32.4855V33.4224H22.6406ZM38.5729 48.3594H31.4271V47.4224C31.6239 42.6813 38.3779 42.6849 38.573 47.4224V48.3594H38.5729ZM33.1844 40.3932C33.1844 39.3921 33.9989 38.5776 35 38.5776C37.4087 38.6773 37.408 42.1095 35 42.2088C33.9988 42.2088 33.1844 41.3944 33.1844 40.3932ZM39.3628 44.5714C38.884 43.8413 38.2272 43.2381 37.4544 42.8239C39.6001 40.6868 38.0615 36.9298 35 36.937C31.9386 36.9298 30.3999 40.6874 32.5457 42.8239C31.7729 43.2381 31.1161 43.8413 30.6374 44.5714C27.3465 42.7358 25.5324 38.7715 26.3422 35.063H30.6068C31.0599 35.063 31.4272 34.6958 31.4272 34.2427V32.4855C31.4272 31.3058 31.0331 30.2166 30.37 29.342C33.115 27.6037 36.8852 27.6038 39.6301 29.342C38.967 30.2166 38.573 31.3058 38.573 32.4855V34.2427C38.573 34.6958 38.9403 35.063 39.3933 35.063H43.658C44.4676 38.7718 42.6537 42.7355 39.3628 44.5714ZM47.3594 33.4224H40.2135V32.4855C40.4103 27.7443 47.1643 27.748 47.3594 32.4855V33.4224Z"
        fill="#33373D"
      />
      <defs>
        <filter
          id="filter0_d_5969_10756"
          x="0"
          y="0"
          width="71"
          height="71"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_5969_10756"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.203922 0 0 0 0 0.352941 0 0 0 0 0.47451 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5969_10756"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5969_10756"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
